// extracted by mini-css-extract-plugin
module.exports = {"selector":"Sd7oW","selectorText":"_3zvFK","selectorItem":"_1wRxD"};